import React, { useContext, useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import FlashTourPackageOption from './FlashTourPackageOption'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import { mediaQueryUp } from 'components/utils/breakpoint'
import config from 'constants/config'
import { sortBy } from 'lib/arrayUtils'
import Heading from 'components/Luxkit/Typography/Heading'
import { SecureWithDepositBanner } from 'components/Common/SecureWithDeposit/SecureWithDepositBanner'
import CurrencyContext from 'contexts/currencyContext'
import { getDepositAmountPercentage, isDepositAvailableOnOffer } from 'lib/depositsUtils'
import cn from 'clsx'

const PackageSelectionWrapper = styled.div`
  margin-top: ${rem(12)};

  ${mediaQueryUp.sm} {
    position: relative;
  }

  &.deposits {
    padding-top: ${rem(30)};
  }
`

const BannerWrapper = styled.div`
  padding-top: ${rem(30)};
  padding-right: ${rem(10)};
  padding-left: ${rem(10)};

  ${mediaQueryUp.sm} {
    padding-top: ${rem(30)};
    padding-right: 0;
    padding-left: 0;
  }
`

interface Props {
  availableForPurchase: boolean;
  offer: App.Offer;
  packages: Array<App.Package>;
  defaultDepositAmountPercentage: number;
}

function FlashTourPackageOptions(props: Props) {
  const {
    offer,
    availableForPurchase,
    defaultDepositAmountPercentage,
  } = props

  const depositAmountPercentage = getDepositAmountPercentage(offer, defaultDepositAmountPercentage)
  const sortedOptions = useMemo(() => sortBy(offer.packages, pkg => pkg.sortOrder, 'asc'), [offer.packages])
  const currentCurrency = useContext(CurrencyContext)
  const depositsAvailable = isDepositAvailableOnOffer(offer, currentCurrency, null, offer.lowestPricePackage.price)

  return (
    <Pane type="light" id="Package-Options">
      <PaneBody size="lg-y">
        <Heading variant="heading2" format="titlecase" as="h2" align="center">
          {config.brandConfig.travelSynonym} Options
        </Heading>
        <LayoutContainer>
          {depositsAvailable &&
            <BannerWrapper>
              <SecureWithDepositBanner offerType={offer.type} depositAmountPercentage={depositAmountPercentage} depositThresholds={offer.depositThresholds} depositAmount={offer.depositAmount}/>
            </BannerWrapper>
          }
          <PackageSelectionWrapper className={cn({ deposits: depositsAvailable })}>
            {sortedOptions.map((packageOption) => (
              <FlashTourPackageOption
                key={packageOption.uniqueKey}
                offer={offer}
                packageOption={packageOption}
                availableForPurchase={availableForPurchase}
              />
            ))}
          </PackageSelectionWrapper>
        </LayoutContainer>
      </PaneBody>
    </Pane>
  )
}

export default FlashTourPackageOptions
